'use client';

import React from 'react';
import { useInView } from '@/lib/useInView';
import CTAButton from '../ui/CTAButton';
import { trackEvent } from '@/lib/analytics';

type LayoutTitleText_1_2Props = {
  eyebrow?: string;
  heading: React.ReactNode;
  bodyText: React.ReactNode;
  ctaText?: string;
  ctaHref?: string;
  ctaOnClick?: () => void;
  pathname?: string;
  className?: string;
  leftColumnClassName?: string;
  rightColumnClassName?: string;
};

export default function LayoutTitleText_1_2({
  eyebrow,
  heading,
  bodyText,
  ctaText,
  ctaHref,
  ctaOnClick,
  pathname,
  className = '',
  leftColumnClassName = '',
  rightColumnClassName = '',
}: LayoutTitleText_1_2Props) {
  const { ref: leftColumnRef } = useInView<HTMLDivElement>();
  const { ref: rightColumnRef } = useInView<HTMLDivElement>();

  const handleCTAClick = () => {
    if (ctaOnClick) {
      ctaOnClick();
    } else if (ctaHref && pathname) {
      trackEvent('content_block_click', {
        click_text: ctaText || 'CTA',
        click_url: ctaHref,
        page_path: pathname,
      });
    }
  };

  return (
    <section className={`title-info-container mb-24 mt-24 global-padding ${className}`}>
      <div className="flex flex-col">
        <div ref={leftColumnRef} className="animate-in-view flex flex-col md:flex-row md:items-start">
          <div className={`md:w-1/3 max-w-[31.25rem] ${leftColumnClassName}`}>
            {eyebrow && (
              <p className="eyebrow-lg havas-red mb-[0.75rem]" style={{ letterSpacing: "0.05em" }}>
                {eyebrow}
              </p>
            )}
            <div className="heading mx-auto">
              <h3 className="body-xl-display-wwd mb-6 lg:mb-[1.25rem]">{heading}</h3>
            </div>
          </div>
        </div>
        <div ref={rightColumnRef} className="animate-in-view flex flex-col md:flex-row md:items-start">
          <div className={`md:w-2/3 md:ml-auto flex flex-col gap-4 ${rightColumnClassName}`}>
            {bodyText}
            {ctaText && ctaHref && (
              <div className="flex mt-[0.4375rem] lg:mt-[0.75rem]">
                <CTAButton 
                  href={ctaHref} 
                  showArrow
                  onClick={handleCTAClick}
                >
                  {ctaText}
                </CTAButton>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}

